import React, { createContext, useContext } from 'react';

/**
 * SessionContext — Provider is mounted in pages/SessionDetail.jsx.
 * Exposes ALL session state + handlers as a single bag so child tab
 * components can consume via useSession() without prop drilling.
 *
 * Do NOT put derived/computed values in the provider value that would
 * cause the whole tree to re-render — SessionDetail memoizes the bag
 * or re-creates it each render (same as inline JSX previously did).
 */
export const SessionContext = createContext(null);

export const useSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error('useSession() must be used inside <SessionContext.Provider>. Are you rendering a SessionDetail child outside its Provider?');
  }
  return ctx;
};
